import { StatisticalAnalysisSidebarBase, StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { uniqueId } from 'lodash'
import { StatisticalAnalysisHeaderNavigationItems, StatisticalAnalysisHeaderValues, StatisticalAnalysisTypeNavigation } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisActivityTypes, StatisticalAnalysisDossiers, StatisticalAnalysisEnumsAndKeys, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisSearchBySidebarComboItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-by/statistical-analysis-sidebar-search-by.model'
import i18n from '@/lang/i18n'
import { StatisticalAnalysisViewDetailChartFilterAxisCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-axis/statistical-analysis-view-detail-chart-filters-axis.model'
export interface StatisticalAnalysisActivityDossierModelSearchInfo {
    typeSearch: Nullable<StatisticalAnalysisSidebarItemCombo>
    states: Nullable<StatisticalAnalysisSearchBySidebarComboItemCombo[]>
    laboratories: Nullable<LaboratoryStatisticalAnalysisSidebarDateInput[]>
    startDate: Nullable<Date>
    endDate: Nullable<Date>
}

export interface StatisticalAnalysisActivityDossierExternalInfo extends StatisticalAnalysisActivityDossierModelSearchInfo{
    trackingGeneralSelected: Nullable<StatisticalAnalysisHeaderNavigationItems<string>>
}

export const navigationItems: StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisActivityTypes>[] = [
    {
        label: i18n.tc('statisticalAnalysis.dossiers.serviceActivity.caseTotal'),
        key: StatisticalAnalysisActivityTypes.TOTAL,
        value: 0,
        icon: 'fal fa-chart-network'
    },
    {
        label: i18n.tc('statisticalAnalysis.dossiers.serviceActivity.valueUnitTotal'),
        key: StatisticalAnalysisActivityTypes.UCL,
        value: 0,
        icon: 'fal fa-coins'
    },
    {
        label: i18n.tc('statisticalAnalysis.dossiers.serviceActivity.workUnitTotal'),
        key: StatisticalAnalysisActivityTypes.URV,
        value: 0,
        icon: 'fal fa-user-md'
    }
]

const StatisticalAnalysisActivityStatisticsDossierAxisYList =
    (): StatisticalAnalysisViewDetailChartFilterAxisCombo[] => {
        const valuesYAxis = [
            StatisticalAnalysisEnumsAndKeys.ACTIVITY_TOTAL.getModel(),
            StatisticalAnalysisEnumsAndKeys.URV.getModel(),
            StatisticalAnalysisEnumsAndKeys.UCL.getModel()
        ]
        return valuesYAxis.map((yAxisValue: StatisticalAnalysisViewDetailChartFilterAxisCombo) => {
            yAxisValue.text = i18n.tc(yAxisValue.text)
            return yAxisValue
        })
    }

export interface StatisticalAnalysisActivityDossierState extends StatisticalAnalysisSidebarBase {
    headerData: StatisticalAnalysisHeaderValues,
    viewDetail: StatisticalAnalysisViewDetailParams
    externalInfo: StatisticalAnalysisActivityDossierExternalInfo
    promiseNavigationItems: Nullable<Promise<void>>
}
export const initialStatisticalAnalysisActivityDossierState =
    (): StatisticalAnalysisActivityDossierState => ({
        sidebar: {
            title: 'statisticalAnalysis.sections.serviceActivity',
            id: 'service-activity',
            components: [
                {
                    name: 'StatisticalAnalysisSidebarSearchBy',
                    id: uniqueId(),
                    props: {
                        filterByStates: true,
                        options: [
                            StatisticalAnalysisEnumsAndKeys.CASE.getModel()
                        ],
                        preselection: StatisticalAnalysisEnumsAndKeys.CASE.getModel()
                    }
                },
                {
                    name: 'StatisticalAnalysisSidebarDateAndCenters',
                    id: uniqueId(),
                    props: { }
                }
            ]
        },
        headerData: {
            header: {
                total: 0,
                showTotal: false,
                startDate: new Date(),
                endDate: new Date(),
                elementType: 'statisticalAnalysis.dossiers.serviceActivity.activityResults'
            },
            navigationItems: [],
            navigationType: StatisticalAnalysisTypeNavigation.INFO,
            styles: {
                background: require('@/img/service-activity-bg.jpg'),
                icon: 'far fa-chart-network'
            }
        },
        viewDetail: {
            dossier: StatisticalAnalysisDossiers.ACTIVITY,
            table: {
                contextMenuItems: {
                    detailChart: false,
                    detailList: true
                },
                temporalFilter: {
                    isShow: false
                }
            },
            chart: {
                axis: {
                    xAxis: {
                        show: true,
                        mainCombo: {
                            list: [],
                            selected: null
                        },
                        associatedCombo: {
                            list: [],
                            selected: null
                        }
                    },
                    yAxis: {
                        show: true,
                        mainCombo: {
                            list: StatisticalAnalysisActivityStatisticsDossierAxisYList(),
                            selected: StatisticalAnalysisActivityStatisticsDossierAxisYList()[0]
                        }
                    }
                },
                showExtendedFilters: false
            }
        },
        externalInfo: {
            typeSearch: null,
            states: [],
            laboratories: [],
            startDate: null,
            endDate: null,
            trackingGeneralSelected: null
        },
        promiseNavigationItems: null
    })
